module.exports = __webpack_public_path__ + "static/media/communal-eh.2fc987d7.png";